// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3ALkt","checkboxCol":"Table_checkboxCol__NaSRD","emailCol":"Table_emailCol__32oL_","actionCol":"Table_actionCol__WTTQ6"};